import Utils from '../../utils/utils';

module.exports = ({ NPM_NODE_CLIENT, URL_CLIENT }) => `composer require flagsmith/flagsmith-php-client
`;
